// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesResult = objectOf({
  no_data: maybe(boolean, true),
  total_count: number,
  date: maybe(number, true),
  is_estimated: maybe(boolean, true),
  customer_groups: arrayOf(
    objectOf({
      name: string,
      display_name: string,
      description: string,
      count: number,
      pct: number,
    })
  ),
});
